import { msalInstance } from '@/auth/msalClient';
import { PolicyCacheService } from './policyCacheService';

/**
 * Clears all MSAL cache from browser storage (localStorage, sessionStorage, and IndexedDB)
 */
export function clearClientCache(): void {
  try {
    localStorage.clear();
    console.log('localStorage cleared');
  } catch {
    console.warn('Error clearing localStorage');
  }
  PolicyCacheService.clearCache();
  try {
    sessionStorage.removeItem('msal.activeAccountId');
    console.log('sessionStorage activeAccountId cleared');
    console.log('sessionStorage length', sessionStorage.length);
  } catch {
    console.warn('Error clearing sessionStorage');
  }
  // Delete MSAL IndexedDB stores
  if (window.indexedDB) {
    ['msal.db', 'msal.token.cache.db'].forEach(dbName => {
      const request = window.indexedDB.deleteDatabase(dbName);
      request.onerror = () => console.warn(`Failed to delete IndexedDB: ${dbName}`);
      request.onsuccess = () => console.log(`Deleted IndexedDB: ${dbName}`);
    });
  }
}

/**
 * Logs the user out via MSAL redirect and then clears client cache
 */
export function logoutWithRedirect(postLogoutUri: string) {
    return msalInstance.logoutRedirect({ postLogoutRedirectUri: postLogoutUri })
      .finally(() => clearClientCache());
  }